export default __webpack_public_path__ + "static/media/LDO.968b6cd0.png";